import { CockpitPeriodKey } from '../model/types'

/** `fullYear` covers every quarter; `q1`-`q4` each cover just themselves; `ytd` covers every
 *  quarter too, but is further narrowed below to just the ones up to `currentFQuarter` — the
 *  quarters actually closed so far this year. Quarter `5` (the full-year total row) is never
 *  covered by any key. */
const QUARTERS_BY_PERIOD: Record<CockpitPeriodKey, number[]> = {
  fullYear: [1, 2, 3, 4],
  q1: [1],
  q2: [2],
  q3: [3],
  q4: [4],
  ytd: [1, 2, 3, 4],
}

/** The fiscal quarters (1–4) the selected periods cover, ascending and each listed once — what
 *  `getFilteredFinSobRows` scopes the Fin/SOB rows to. */
export const getCockpitPeriodQuarters = (
  periods: CockpitPeriodKey[],
  currentFQuarter: number
): number[] => {
  const quarters = new Set(periods.flatMap((period) => QUARTERS_BY_PERIOD[period]))
  const isYtd = periods.includes('ytd')

  return [...quarters]
    .filter((quarter) => !isYtd || quarter <= currentFQuarter)
    .sort((left, right) => left - right)
}
